import { RawMemberWithProps } from 'interfaces/member'
import { createAction, createPayloadAction } from 'helpers/actionsHelpers'
import { PayloadAction, SimpleAction } from 'interfaces/action'

export const GET_MEMBER_INFO = 'GET_MEMBER_INFO' as const
type GetMemberInfo = SimpleAction<typeof GET_MEMBER_INFO>
export const getMemberInfoActionCreator = (): GetMemberInfo =>
  createAction(GET_MEMBER_INFO)

export const SET_MEMBER_INFO = 'SET_MEMBER_INFO' as const
type SetMemberInfo = PayloadAction<typeof SET_MEMBER_INFO, RawMemberWithProps>
export const setMemberInfoActionCreator = (payload: RawMemberWithProps): SetMemberInfo =>
  createPayloadAction(SET_MEMBER_INFO, payload)

export const GET_MEMBER_AUTH_STATUS = 'GET_MEMBER_AUTH_STATUS' as const
type GetMemberAuthStatus = SimpleAction<typeof GET_MEMBER_AUTH_STATUS>
export const getMemberAuthStatusActionCreator = (): GetMemberAuthStatus =>
  createAction(GET_MEMBER_AUTH_STATUS)

// ===========================================================================//
//                                  STATUS ACCOUNT                            //
// ===========================================================================//

export const DELETE_MEMBER_ACCOUNT = 'DELETE_MEMBER_ACCOUNT' as const
type DeleteMemberAccount = SimpleAction<typeof DELETE_MEMBER_ACCOUNT>
export const deleteMemberAccountActionCreator = (): DeleteMemberAccount =>
  createAction(DELETE_MEMBER_ACCOUNT)

export type MemberActions =
  | GetMemberInfo
  | SetMemberInfo
  | GetMemberAuthStatus
  | DeleteMemberAccount

export default MemberActions
